module.exports = __webpack_public_path__ + "img/mail-services-blue.442e4e91.svg";